module.exports = __webpack_public_path__ + "static/media/yogo.5a74d992.jpg";